import React from 'react';
import Base from 'client/components/base';
import Image from 'client/components/common/image';
import { Link } from 'react-router';
import baseUrl from 'server/routes/base-url';

export default class ChannelCover extends Base {
  constructor(props) {
    super(props);
  }

  render() {
    if (!this.props.model) {
      return <div className={this.css()} />;
    }

    let width = this.props.width || null;
    let style = this.props.style || {};

    if (width && style.width === undefined) {
      style.width = width;
      style.height = height;
    }

    if (this.props.showInfo === 'true') {
      return (
        <div
          id={this.props.id}
          onMouseOver={this.props.onMouseOver}
          className={this.css()}
          style={style}
        >
          <Link to={baseUrl + this.props.model.url}>
            <div className="image-wrapper">
              {this.acastPlusLogo}
              <Image model={this.props.model} width={width} />
            </div>
            <div className="info">
              <h3>{this.props.model.name}</h3>
              <h4>{this.props.model.author}</h4>
              <p>
                {this.cut(
                  this.props.model.summary || this.props.model.description,
                  70
                )}
              </p>
            </div>
          </Link>
        </div>
      );
    } else {
      return (
        <div
          id={this.props.id}
          onMouseOver={this.props.onMouseOver}
          className={this.css()}
          style={style}
        >
          <Link to={baseUrl + this.props.model.url}>
            {this.acastPlusLogo}
            <Image model={this.props.model} width={width} />
          </Link>
        </div>
      );
    }
  }

  get acastPlusLogo() {
    let haveChannelProducts =
      this.props.model &&
      this.props.model.channelProducts &&
      this.props.model.channelProducts.length;
    if (haveChannelProducts) {
      return (
        <img
          className="acast-plus-logo"
          src="https://cdn.acast.com/images/icons/icon-acast-plus-channel-cover.png"
        />
      );
    }
    return '';
  }
}



// WEBPACK FOOTER //
// ./client/components/common/channel-cover/channel-cover.es6